const authConfig = {
  // oidc
  issuer: process.env.REACT_APP_OIDC_ISSUER,
  redirectUri: process.env.REACT_APP_OIDC_REDIRECT_URI,
  clientId: process.env.REACT_APP_OIDC_CLIENT_ID,
  // service url
  serviceUrl: process.env.REACT_APP_INTERNAL_API,
}

export default authConfig